import styled from "styled-components";

import DefaultRow from "components/Form/Row";

import { COLORS } from "constants/colorScheme";

export const ButtonContainer = styled.div`
  display: flex;
  width: 140px;
`;

export const FormContainer = styled.div`
  padding: 32px;

  background-color: ${COLORS.WHITE};
  border-radius: 10px;
`;

export const Row = styled(DefaultRow)`
  margin-bottom: 0;

  :not(:last-child) {
    margin-bottom: 40px;
  }
`;

export const SearchFieldContainer = styled.div`
  width: 500px;
  margin-right: 24px;
`;

export const UserInfo = styled.div`
  flex-direction: column;
`;

export const UserInfoField = styled.div`
  height: 54px;
  margin-bottom: 12px;
`;
